import { req } from "../js/config";
import { ToHTML, ToHTMLWithFormatting } from "../js/base";
import { async } from "regenerator-runtime";

let PageData = ''

const Initialize = async () => {
  //getPageData
  await getPageData();
  console.log("Initialize ~ PageData", PageData)
  await generatePageHTML();
}
const getPageData = async () => {

  console.log('getPageData from the server');
  PageData = await req(`Sections/examCael`).catch(function (response) {
  });
  var t = await req(`Sections/examSidebar`).catch(function (response) {
  });
  var u = await req(`Sections/examFooter`).catch(function (response) {
  });
  u.data.forEach(e => { PageData.data.push(e) });



  t.data.forEach(e => { PageData.data.push(e) });


  return PageData;
}

const SectionsLeft_Tpl = async (d) => {
  let divs = '';

  d.forEach(e => {

    divs += `<div class="border mb-4">
              <h6 class="text-dark px-4 py-2 bg-light mb-0">${e.header}</h6>
                <div class="p-4 border-top">
                  <span class="lead text-dark fw-6">${e.title}</span>
                  <p> ${ToHTMLWithFormatting(e.body1)}</p>
                </div></div>`
  })


  return divs;
}
const SectionsRight_Tpl = async (d) => {
  let divs = '';

  d.forEach(e => {

    divs += `
      <div class="widget">
    <h6 class="widget-title">${e.header}</h6>
    <div class="widget-content">
    ${ToHTMLWithFormatting(e.body1)}
    </div>
</div>
`
  })


  return divs;
}



const renderSectionsLeft_Tpl = async (d) => {
  console.log("🚀 ~ file: main.js ~ line 26 ~ constrenderSectionsLeft_Tpl= ~ d", d)
  let tpl = ` 
                ${await SectionsLeft_Tpl(d)}
 
                `

  document.querySelector('#pageexamcaelleft').innerHTML = tpl;

}
const renderSectionsRight_Tpl = async (d) => {
  console.log("🚀 ~ file: main.js ~ line 26 ~ constrenderSectionsRight_Tpl= ~ d", d)
  let tpl = `      <div class="widgets">
              

  ${await SectionsRight_Tpl(d)}
  



</div>`

  document.querySelector('#pageexamcaelright').innerHTML = tpl;

}
const Footer_Tpl = async (d) => {
  let divs = '';

  d.forEach(e => {

    divs += `




<div class="col-sm-6 col-xl-3 col-lg-4 mb-4 mb-lg-0">
<h5 class="footer-title">${e.title}</h5>
<div class="footer-contact-info" >
  
${ToHTMLWithFormatting(e.body1)}
</div>
</div>
`
  })


  return divs;
}

const renderFooter_Tpl = async (d) => {
  console.log('line no 142', d)



  let tpl = `

               
               ${await Footer_Tpl(d)}
               
                 
               <div class="col-sm-6 col-lg-3">
               <h5 class="footer-title">Subscribe us</h5>
               <p>Sign up to our newsletter to get the latest news and offers.</p>
               <form>
                 <div class="form-group">
                   <input type="email" class="form-control" placeholder="Email*">
                 </div>
                 <button type="submit" class="btn btn-sm btn-primary">Subscribe</button>
               </form>
             </div>
               
               
               
               
               
               `

  document.querySelector('#pageexamcaelFooter').innerHTML = tpl;

}
const generatePageHTML = async () => {
  //render all sections here
  renderSectionsLeft_Tpl(PageData.data.filter(f => f.pageId.includes('examCael-Left')));
  renderSectionsRight_Tpl(PageData.data.filter(f => f.pageId.includes('examSidebar')));
  renderFooter_Tpl(PageData.data.filter(f => f.pageId.includes('examFooter')));
}

Initialize();

document.addEventListener('DOMContentLoaded', () => {
  console.log('DOMContentLoaded')

})